import React from 'react';
import { Eye, FileText, CheckCircle, XCircle, AlertCircle } from 'lucide-react';
const mockData = [{
  id: 1,
  clientId: '12345',
  clientName: 'Juan Pérez',
  date: '2024-03-15',
  reason: 'Motivos Financieros',
  status: 'pending',
  lastUpdate: '2024-03-15 10:30'
}, {
  id: 2,
  clientId: '67890',
  clientName: 'María García',
  date: '2024-03-14',
  reason: 'Mejor Oferta',
  status: 'approved',
  lastUpdate: '2024-03-15 09:15'
}, {
  id: 3,
  clientId: '11223',
  clientName: 'Carlos Rodríguez',
  date: '2024-03-13',
  reason: 'Motivos Personales',
  status: 'rejected',
  lastUpdate: '2024-03-14 15:45'
}];
const getStatusBadge = status => {
  const statusConfig = {
    pending: {
      color: 'bg-yellow-100 text-yellow-800',
      icon: AlertCircle,
      text: 'Pendiente'
    },
    approved: {
      color: 'bg-green-100 text-green-800',
      icon: CheckCircle,
      text: 'Aprobado'
    },
    rejected: {
      color: 'bg-red-100 text-red-800',
      icon: XCircle,
      text: 'Rechazado'
    }
  };
  const config = statusConfig[status] || statusConfig.pending;
  const Icon = config.icon;
  return <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${config.color}`} data-id="element-1314">
      <Icon className="w-4 h-4 mr-1" data-id="element-1315" />
      {config.text}
    </span>;
};
export const WithdrawalTable = ({
  filters
}) => {
  return <div className="bg-white rounded-lg shadow overflow-hidden" data-id="element-1316">
      <div className="overflow-x-auto" data-id="element-1317">
        <table className="min-w-full divide-y divide-gray-200" data-id="element-1318">
          <thead className="bg-gray-50" data-id="element-1319">
            <tr data-id="element-1320">
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1321">
                Cliente
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1322">
                Fecha
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1323">
                Motivo
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1324">
                Estado
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1325">
                Última Actualización
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1326">
                Acciones
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200" data-id="element-1327">
            {mockData.map(item => <tr key={item.id} data-id="element-1328">
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-1329">
                  <div className="text-sm font-medium text-gray-900" data-id="element-1330">
                    {item.clientName}
                  </div>
                  <div className="text-sm text-gray-500" data-id="element-1331">
                    ID: {item.clientId}
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-1332">
                  {item.date}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" data-id="element-1333">
                  {item.reason}
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-1334">
                  {getStatusBadge(item.status)}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-1335">
                  {item.lastUpdate}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium" data-id="element-1336">
                  <div className="flex space-x-3" data-id="element-1337">
                    <button className="text-blue-600 hover:text-blue-900" data-id="element-1338">
                      <Eye className="h-5 w-5" data-id="element-1339" />
                    </button>
                    <button className="text-gray-600 hover:text-gray-900" data-id="element-1340">
                      <FileText className="h-5 w-5" data-id="element-1341" />
                    </button>
                  </div>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </div>;
};